import {Box, HStack, VStack} from 'platform/foundation';

import {ReactNode} from 'react';

import {SALES_LEAGUE_CONTENT_MAX_WIDTH} from '../constants/SALES_LEAGUE_CONTENT_MAX_WIDTH';

const BOARD_SPACING = 6;

interface SalesLeagueBoardLayoutProps {
  /** Rendered above the content in every state, so the period switcher never disappears. */
  header: ReactNode;
  children: ReactNode;
}

/** The centred, width-capped column both boards live in, loading or loaded. */
export function SalesLeagueBoardLayout(props: SalesLeagueBoardLayoutProps) {
  return (
    <HStack justify="center">
      <Box width="100%" maxWidth={SALES_LEAGUE_CONTENT_MAX_WIDTH}>
        <VStack spacing={BOARD_SPACING}>
          {props.header}
          {props.children}
        </VStack>
      </Box>
    </HStack>
  );
}
